


























































import { Vue, Component } from "vue-property-decorator";
import { LearningGroup as ILearningGroup } from "@/api-v2/learning-group/models/learning-group";
import CPage from "@/components/form/CustomPage/CPage.vue";
import { learningGroupsApi } from "@/getinfo-api";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import LearningGroupStudentTable from "@/components/learning-group/LearningGroupStudentTable.vue";
import { AxiosError } from "axios";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";

@Component({
  components: { LearningGroupStudentTable, TextField, CBlock, CPage }
})
export default class LearningGroup extends Vue {
  group!: ILearningGroup & { registrationsIds?: string[] };
  isLoading: boolean = false;

  data() {
    return {
      group: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "learningGroupList" },
        label: this.$tc(this.$translate.TrainingGroups)
      },
      {
        label: this.group?.title ?? ""
      }
    ];
  }

  getGroup() {
    learningGroupsApi.Group.getLearningGroup(this.$route.params.id).then(
      res => {
        this.group = res.data;
      }
    );
  }

  removeStudent(removeId: string) {
    let form = {
      ...this.group
    };
    form.registrationsIds = [
      ...form.registrations
        .map(({ id }) => id)
        .filter(studentId => studentId !== removeId)
    ];
    learningGroupsApi.Group.editLearningGroup(this.$route.params.id, form)
      .then(() => {
        this.group.registrations = this.group.registrations.filter(
          el => el.id !== removeId
        );
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  created() {
    this.getGroup();
  }
}
